export default __webpack_public_path__ + "static/media/bg-1.e9cade6c.png";